import React from 'react'

import InvalidOrExpiredPage from '@/pages/InvalidOrExpiredPage'

const InvalidESignatureMessage: React.FC = () => {
  return (
    <InvalidOrExpiredPage
      content={
        <p>
          This link is either invalid or has expired. If you already submitted
          the eSignature letter, there is nothing else for you to do.
        </p>
      }
    />
  )
}

export default InvalidESignatureMessage
